import * as React from 'react';
import { connect } from 'react-redux';

import * as PassActions from '../../actions/password';
import * as LoginActions from '../../actions/login';
import * as AuthCreators from '../../creators/auth';
import * as AuthActions from '../../actions/auth';
import AuthFieldSet from './AuthFieldSet';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';

interface DispatchProps {
  receiveLoginValue: (text: string) => void;
  receivePassValue: (text: string) => void;
  fetchAuthAction: (login: string, password: string) => void;
  errorMessageInit: (payload?: any) => void;
}

interface OwnProps {
  loginValue: string;
  passValue: string;
  isErrorMessage: boolean;
}

interface Props extends DispatchProps, OwnProps {}

function AuthForm (props: Props) {

  const onPasswordEnter = React.useCallback((e) => {
    props.receivePassValue(e.target.value);
  }, [props.receivePassValue]);

  const onLoginEnter = React.useCallback((e) => {
    props.receiveLoginValue(e.target.value);
  }, [props.receiveLoginValue]);

  const sendLoginPass = React.useCallback((e) => {
    e.preventDefault();
    if (!props.loginValue || !props.passValue) {
      alert('Please enter username or password!');
    } else {
      props.fetchAuthAction(props.loginValue, props.passValue);
    }
  }, [props.loginValue, props.passValue, props.fetchAuthAction]);

  const errorMessageInit = React.useCallback(() => {
    setTimeout(() => {
      props.errorMessageInit();
    }, 90000);
  }, [props.errorMessageInit]);

  React.useEffect(errorMessageInit, [props.isErrorMessage, errorMessageInit]);

  return (
    <form className='auth-form '>
      <div className='logo-title'>{'User-card'}</div>
      <AuthFieldSet
        onChange={onLoginEnter}
        placeholder='IPA Username'
        type='text'
        fildsetValue={props.loginValue} />
      <AuthFieldSet
        onChange={onPasswordEnter}
        placeholder='IPA Password'
        type='password'
        fildsetValue={props.passValue} />

      {
        props.isErrorMessage ?
          <ErrorMessage message='Incorrect username or password' /> :
          null
      }

      <button
        onClick={sendLoginPass}
        className='primary-button auth-button m-auto'>{'Sign in'}</button>
    </form>
  );
}

const mapStateToProps = (state) => {
  return {
    passValue: state.password.passValue,
    loginValue: state.login.loginValue,
    isErrorMessage: state.auth.isErrorMessage,
  };
};

const mergeProps = (stateProps, dispatchProps, props) => {
  return {
    ...stateProps,
    receiveLoginValue: dispatchProps.receiveLoginValue,
    receivePassValue: dispatchProps.receivePassValue,
    fetchAuthAction: dispatchProps.fetchAuthAction,
    errorMessageInit: dispatchProps.errorMessageInit,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    receiveLoginValue: LoginActions.fetchLoginSuccess,
    receivePassValue: PassActions.fetchPasswordSuccess,
    fetchAuthAction: AuthCreators.fetchAuthAction,
    errorMessageInit: AuthActions.fetchAuthErrorMessageInit,
  }, mergeProps
)(React.memo(AuthForm));
